import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { SectionHead } from "@/components/common/Reveal";

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="overflow-hidden bg-white py-20 md:py-28">
    <div className="container-x">
      <SectionHead eyebrow="मरीज़ों के अनुभव · Patient Stories" title="भरोसा, जो मरीज़ों ने कमाया" />
      <div className="mt-12 flex snap-x gap-5 overflow-x-auto pb-4">
        {TESTIMONIALS.map((t, i) => (
          <article key={t.name} data-testid={`testimonial-${i}`} className="relative w-[85%] shrink-0 snap-start rounded-[26px] border border-line bg-sand p-7 sm:w-[380px]">
            <Quote className="absolute right-6 top-6 h-8 w-8 text-maroon/15" />
            <div className="flex gap-0.5 text-amber-500">{Array.from({ length: t.rating }).map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}</div>
            <p className="mt-4 text-[16px] leading-relaxed text-ink/85">“{t.quote}”</p>
            <div className="mt-6 flex items-center gap-3">
              <img src={t.photo} alt={t.name} className="h-11 w-11 rounded-full object-cover" />
              <div><p className="font-semibold text-ink">{t.name}</p><p className="text-xs text-muted2">{t.place} · {t.treatment}</p></div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
